// Texty detailu produktu (productDetail.js) a regexy, kterými modul čte nativní
// text Shoptetu (dostupnost, hodnocení, množstevní slevy) — slovenské dvojče.
import { plural } from '../plural.js';
import SHOP from '../../../config/shop.js';
import { NBSP } from '../../modules/money.js';

export default {
  detailLink: 'Podrobné informácie',
  warrantyStrong: 'Záruka 2 roky',
  warrantyRest: 'Poskytujeme záručný aj pozáručný servis',
  advisor: 'Potrebujete poradiť?',
  advisorCta: 'Poradňa',
  expert: 'Odborník odpovedá na vaše otázky',
  askProduct: 'Opýtať sa na produkt',
  manual: 'Návod',
  filesManual: 'Návod k produktu',
  filesManuals: 'Návody k produktu',
  filesMixed: 'Návod a ďalšie materiály',
  filesDocs: 'Materiály k produktu',
  fileCtaManual: 'Stiahnuť návod',
  fileCtaDoc: 'Stiahnuť',
  fileCtaVideo: 'Prehrať video',
  fileCtaLink: 'Otvoriť',
  fileVideo: 'Video',
  fileNewWindow: 'otvorí sa v novom okne',
  manualRe: /n[áa]vod|manu[áa]l/i,
  rateCta: 'Napísať hodnotenie',
  rateMore: 'Zobraziť ďalšie hodnotenia',
  rateShare: 'zákazníkov dáva 4 a viac hviezdičiek',
  rateStarsOnly: 'Zákazníci hodnotili hviezdičkami, slovné recenzie zatiaľ nemáme na zobrazenie.',
  specsTitle: 'Parametre',
  specsTech: 'Technické',
  specsExtra: 'Doplnkové',
  discAnswers: 'Odpovedá',
  discSideRole: 'odpovedá na otázky',
  discSideText: 'Nenašli ste odpoveď? Opýtajte sa priamo tu. Odpovedáme verejne, aby to pomohlo aj ďalším zákazníkom.',
  discUrgent: 'Ponáhľate sa?',
  discPending: 'zatiaľ bez odpovede',
  code: 'Kód:',
  brand: 'Značka:',
  bestseller: 'Bestseller',
  sale: 'zľava',
  save: 'ušetríte',
  photos: (n) => plural(n, ['fotka', 'fotky', 'fotiek']),
  rowPrev: 'Predchádzajúce produkty',
  rowNext: 'Ďalšie produkty',
  rowAll: 'Zobraziť všetko',
  rowSub: 'Hodí sa k tomuto produktu',
  upsell: 'Hodí sa k tomu:',
  inStockSuffix: '· skladom',
  lastOne: 'Posledný kus skladom',
  lastPieces: 'Posledné kusy skladom',
  stepOrder: 'Objednáte',
  stepShip: 'Odošleme',
  stepDeliver: 'Doručíme',
  shippingFrom: 'Doprava',
  shippingFromPrefix: 'od',
  pickup: 'odber v Bíline',
  pickupSoon: 'už',
  promoBox: (carrier) => (carrier ? carrier + ' na' : 'Na') + ' výdajné miesto',
  promoUntil: (until, maxKg) => 'Akcia do ' + until + ' · zásielky do ' + maxKg + NBSP + 'kg',
  free: 'zadarmo',
  countdown: 'zostáva',
  brandAll: 'Všetky produkty',
  brandTitle: 'Značka',
  nav: 'Obsah stránky',
  soldoutTitle: 'Tento produkt je vypredaný',
  soldoutText:
    'Nevieme, kedy bude opäť skladom. Postrážime to za vás a dáme vám vedieť ' +
    'e-mailom, hneď ako bude opäť k dispozícii.',
  soldoutPrice: 'cena pred vypredaním',
  soldoutWatch: 'Strážiť dostupnosť',
  soldoutNote: 'Stráženie je zadarmo a e-mail použijeme len na toto jedno upozornenie.',
  soldoutState: 'Momentálne nedostupné',
  altTitle: 'Môžeme ponúknuť alternatívy',
  altSub: 'Podobné produkty, ktoré máme práve skladom',
  inStock: 'Skladom',
  call: (phone) => 'Zavolať ' + phone,
  anchors: {
    description: 'Popis',
    parametry: 'Parametre',
    poradna: 'Poradňa',
    relatedFiles: 'Návod',
    ratingTab: 'Hodnotenie',
    productDiscussion: 'Diskusia',
    manufacturerDescription: 'Značka',
    souvisejici: 'Súvisiace',
    podobne: 'Podobné',
  },
  // ověřeno v dev/sk/product.html: „Skladom", „…je 0,0 z 5 hviezdičiek"
  inStockRe: /^skladom/i,
  // SK: neověřeno ve fixtures („Momentálne nedostupné")
  soldOutRe: /nedostupn/i,
  // SK: neověřeno ve fixtures (SK nabízí jen GLS/PPL, osobní odběr nemá)
  pickupRe: /osobn/i,
  ratingAvgRe: /(\d+(?:[.,]\d+)?)\s*z\s*5/,
  // SK: neověřeno ve fixtures („5 - 9 ks = zľava 5 %")
  qtyBandRe: /^(.*?)\s*=\s*z[ľl]ava\s*(\d+\s*%)$/i,
  numericUnits:
    'kW|W|mW|V|kV|A|mA|Ah|mAh|Wh|kWh|Hz|kHz|dB|Nm|N|kN|kg|g|mg|t|mm|cm|dm|m|km|mm²|cm²|m²|mm³|cm³|m³|l|ml|dl|bar|MPa|kPa|Pa|psi|°C|°|%|‰|ks|h|hod|min|s|ms|KM|HP|k|lm|lx|K|' + SHOP.shop.currencySymbol + '|€|ot\\.\\/min|ot\\/min|l\\/min|l\\/h|m³\\/h|m\\/s|km\\/h|mm\\/s|m\\/min|W\\/kg|kg\\/h|g\\/m²|palcov|"',
  // SK: neověřeno ve fixtures (titulky dlaždic jdou z popisu výrobce)
  brandTileIcons: [
    [/elektr|aku|brús|brus|vŕta|vrta|píl|pil/i, 'bolt'],
    [/záhrad|zahrad|tráv|trav|kos|kro/i, 'leaf'],
    [/dieln|n[áa]radi|kábel|kabel|súprav|suprav|sad|kľúč|kluc/i, 'wrench'],
    [/auto|nab[íi]j/i, 'car'],
  ],
};
